import React from 'react';

const context = React.createContext({ current: window });

export const Provider = context.Provider;
export const Consumer = context.Consumer;
